import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = {
  class: "user-form invoice-setts",
  name: "frmInvSett"
}
const _hoisted_4 = { class: "setting-data" }
const _hoisted_5 = { class: "set-d-inv-h3" }
const _hoisted_6 = { class: "dt_left" }
const _hoisted_7 = { class: "dt_left" }
const _hoisted_8 = { class: "dt_left" }
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", { class: "dt_left" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "dv-border" }, null, -1)
const _hoisted_12 = { class: "setting-data" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "dt_left" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "square" }
const _hoisted_17 = { class: "payt-opt-list" }
const _hoisted_18 = { class: "list-item-inline d-inline me-1" }
const _hoisted_19 = {
  type: "button",
  class: "btn-xs btn-success"
}
const _hoisted_20 = { class: "list-item-inline d-inline" }
const _hoisted_21 = {
  type: "button",
  class: "btn-xs"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "dv-border" }, null, -1)
const _hoisted_23 = { class: "setting-data" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "dt_left" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "payt-opt-list" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "http://www.mtn.co.rw/Content/Pages/115/Mobile_Money_Tariffs"
}, "Mtn Mobile Money Tariff", -1)
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = { class: "list-item-inline d-inline me-1" }
const _hoisted_32 = {
  type: "button",
  class: "btn-xs btn-success"
}
const _hoisted_33 = { class: "list-item-inline d-inline" }
const _hoisted_34 = {
  type: "button",
  class: "btn-xs"
}
const _hoisted_35 = { class: "dt_left" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "payt-opt-list" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "http://www.tigo.co.rw/tigocashtariffs"
}, " Tigo Cash Tariff ", -1)
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = { class: "list-item-inline d-inline me-1" }
const _hoisted_42 = {
  type: "button",
  class: "btn-xs btn-success"
}
const _hoisted_43 = { class: "list-item-inline d-inline" }
const _hoisted_44 = {
  type: "button",
  class: "btn-xs"
}
const _hoisted_45 = { class: "dt_left" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "payt-opt-list" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "http://africa.airtel.com/wps/wcm/connect/africarevamp/rwanda/airtel_money/home/personal/getting_started/getting_started"
}, " Airtel Money Tariff ", -1)
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = { class: "list-item-inline d-inline me-1" }
const _hoisted_52 = {
  type: "button",
  class: "btn-xs btn-success"
}
const _hoisted_53 = { class: "list-item-inline d-inline" }
const _hoisted_54 = {
  type: "button",
  class: "btn-xs"
}
const _hoisted_55 = { class: "dt_left" }
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "payt-opt-list" }
const _hoisted_58 = { class: "stripe-rate-acc" }
const _hoisted_59 = {
  type: "button",
  class: "btn-xs btn-success"
}
const _hoisted_60 = { class: "dt_left" }
const _hoisted_61 = ["src"]
const _hoisted_62 = { class: "payt-opt-list" }
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = {
  type: "button",
  class: "btn-xs btn-success"
}
const _hoisted_65 = { class: "dt_left" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "payt-opt-list" }
const _hoisted_68 = ["placeholder"]
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = {
  type: "button",
  class: "btn-xs btn-success"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InvoiceOptionsSettingsModal = _resolveComponent("InvoiceOptionsSettingsModal")!

  return (_ctx.isStillLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fa', 'fa-spinner'],
          class: "fs-1"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("h2", null, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'cube'],
              class: "d-inline-block me-1"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.language.invoice_options), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.language.current_settings), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", _hoisted_6, _toDisplayString(_ctx.language.currency), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.getCurrencyName), 1),
            _createElementVNode("dt", _hoisted_7, _toDisplayString(_ctx.language.footer), 1),
            _createElementVNode("dd", null, _toDisplayString((_ctx.currentInvoiceSetting.InvoiceFooter.length>0)?_ctx.currentInvoiceSetting.InvoiceFooter:_ctx.language.no_footer), 1),
            _createElementVNode("dt", _hoisted_8, _toDisplayString(_ctx.language.payt_reminders), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString((_ctx.currentInvoiceSetting.SendReminder==0)?_ctx.language.not_activate:_ctx.language.activate) + " ", 1),
              (_ctx.currentInvoiceSetting.SendReminder==1)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "icon-help-alt",
                    style: {"float":"none","display":"inline-block","margin-left":"10px"},
                    title: _ctx.language.invoice_reminder_data
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _hoisted_10,
            _createElementVNode("dd", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-xs btn-success",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openInvoiceSettWindow && _ctx.openInvoiceSettWindow(...args)))
              }, _toDisplayString(_ctx.language.edit_invoice_options), 1)
            ])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.language.recommended_payt_options), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.language.square_payt_opt_msg), 1),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", _hoisted_14, [
              _createElementVNode("img", {
                class: "payt-opt-img",
                src: require('@/assets/images/logo/logo-square.png')
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("dd", _hoisted_16, [
              _createElementVNode("ul", _hoisted_17, [
                _createElementVNode("li", null, _toDisplayString(_ctx.language.square_accepted_cred), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.language.square_accept_funds), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.language.square_accept_support), 1),
                _createElementVNode("li", _hoisted_18, [
                  _createElementVNode("button", _hoisted_19, _toDisplayString(_ctx.language.activate), 1)
                ]),
                _createElementVNode("li", _hoisted_20, [
                  _createElementVNode("button", _hoisted_21, _toDisplayString(_ctx.language.sign_up), 1)
                ])
              ])
            ])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.language.other_payts_options), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.language.other_payts_options_msg), 1),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", _hoisted_25, [
              _createElementVNode("img", {
                class: "payt-opt-img",
                src: require('@/assets/images/logo/mtn_mobile_money.jpg')
              }, null, 8, _hoisted_26)
            ]),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", _hoisted_27, [
                _createElementVNode("li", null, [
                  _createTextVNode(_toDisplayString(_ctx.language.mtn_mobile_money_rate) + " ", 1),
                  _hoisted_28
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "text",
                    name: "MtnMobileMoneyAcct",
                    id: "MtnMobileMoneyAcct",
                    placeholder: _ctx.language.mtn_mobile_money_phone
                  }, null, 8, _hoisted_29)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "password",
                    name: "MtnMobileMoneyPW",
                    id: "MtnMobileMoneyPW",
                    placeholder: _ctx.language.mtn_mobile_money_pw
                  }, null, 8, _hoisted_30)
                ]),
                _createElementVNode("li", _hoisted_31, [
                  _createElementVNode("button", _hoisted_32, _toDisplayString(_ctx.language.connect), 1)
                ]),
                _createElementVNode("li", _hoisted_33, [
                  _createElementVNode("button", _hoisted_34, _toDisplayString(_ctx.language.cancel), 1)
                ])
              ])
            ]),
            _createElementVNode("dt", _hoisted_35, [
              _createElementVNode("img", {
                class: "payt-opt-img",
                src: require('@/assets/images/logo/logo_tigo_cash.png')
              }, null, 8, _hoisted_36)
            ]),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", _hoisted_37, [
                _createElementVNode("li", null, [
                  _createTextVNode(_toDisplayString(_ctx.language.tigo_cash_rate) + "  ", 1),
                  _hoisted_38
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "text",
                    name: "TigoCashAcct",
                    id: "TigoCashAcct",
                    placeholder: _ctx.language.tigo_cash_phone
                  }, null, 8, _hoisted_39)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "password",
                    name: "TigoCashPW",
                    id: "TigoCashPW",
                    placeholder: _ctx.language.tigo_cash_pw
                  }, null, 8, _hoisted_40)
                ]),
                _createElementVNode("li", _hoisted_41, [
                  _createElementVNode("button", _hoisted_42, _toDisplayString(_ctx.language.connect), 1)
                ]),
                _createElementVNode("li", _hoisted_43, [
                  _createElementVNode("button", _hoisted_44, _toDisplayString(_ctx.language.cancel), 1)
                ])
              ])
            ]),
            _createElementVNode("dt", _hoisted_45, [
              _createElementVNode("img", {
                class: "payt-opt-img",
                src: require('@/assets/images/logo/logo_airtel_money.png')
              }, null, 8, _hoisted_46)
            ]),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", _hoisted_47, [
                _createElementVNode("li", null, [
                  _createTextVNode(_toDisplayString(_ctx.language.tigo_cash_rate) + "  ", 1),
                  _hoisted_48
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "text",
                    name: "AirtelMoneyAcct",
                    id: "AirtelMoneyAcct",
                    placeholder: _ctx.language.airtel_cash_phone
                  }, null, 8, _hoisted_49)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "password",
                    name: "AirtelMoneyPW",
                    id: "AirtelMoneyPW",
                    placeholder: _ctx.language.airtel_cash_pw
                  }, null, 8, _hoisted_50)
                ]),
                _createElementVNode("li", _hoisted_51, [
                  _createElementVNode("button", _hoisted_52, _toDisplayString(_ctx.language.connect), 1)
                ]),
                _createElementVNode("li", _hoisted_53, [
                  _createElementVNode("button", _hoisted_54, _toDisplayString(_ctx.language.cancel), 1)
                ])
              ])
            ]),
            _createElementVNode("dt", _hoisted_55, [
              _createElementVNode("img", {
                class: "payt-opt-img",
                src: require('@/assets/images/logo/logo-stripe.svg')
              }, null, 8, _hoisted_56)
            ]),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", _hoisted_57, [
                _createElementVNode("li", null, [
                  _createTextVNode(_toDisplayString(_ctx.language.stripe_accept_cred) + " ", 1),
                  _createElementVNode("ul", _hoisted_58, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.language.stripe_accept_rate), 1)
                  ])
                ]),
                _createElementVNode("li", null, _toDisplayString(_ctx.language.stripe_us_rates), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.language.stripe_bk_pyts_days), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.language.stripe_bk_pyt_name_prev), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.language.stripe_bk_pyt_setup_fees), 1),
                _createElementVNode("li", null, [
                  _createElementVNode("button", _hoisted_59, _toDisplayString(_ctx.language.activate), 1)
                ])
              ])
            ]),
            _createElementVNode("dt", _hoisted_60, [
              _createElementVNode("img", {
                class: "payt-opt-img",
                src: require('@/assets/images/logo/logo-paypal.svg')
              }, null, 8, _hoisted_61)
            ]),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", _hoisted_62, [
                _createElementVNode("li", null, _toDisplayString(_ctx.language.paypal_accept_rate), 1),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "text",
                    name: "PayPalEmail",
                    id: "PayPalEmail",
                    placeholder: _ctx.language.paypal_accept_plc
                  }, null, 8, _hoisted_63)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", _hoisted_64, _toDisplayString(_ctx.language.connect), 1)
                ])
              ])
            ]),
            _createElementVNode("dt", _hoisted_65, [
              _createElementVNode("img", {
                class: "payt-opt-img",
                src: require('@/assets/images/logo/logo-authorize-net.svg')
              }, null, 8, _hoisted_66)
            ]),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", _hoisted_67, [
                _createElementVNode("li", null, _toDisplayString(_ctx.language.authorize_payt_opt_msg), 1),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "text",
                    name: "AuthorizeNetLogin",
                    id: "AuthorizeNetLogin",
                    placeholder: _ctx.language.authorize_api_key_place_log
                  }, null, 8, _hoisted_68)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("input", {
                    type: "password",
                    name: "AuthorizeNetPw",
                    id: "AuthorizeNetPw",
                    placeholder: _ctx.language.authorize_api_key_place_pw
                  }, null, 8, _hoisted_69)
                ]),
                _createElementVNode("li", null, [
                  _createTextVNode(_toDisplayString(_ctx.language.authorize_enable_det_msg) + " ", 1),
                  _createElementVNode("ol", null, [
                    _createElementVNode("li", null, "- " + _toDisplayString(_ctx.language.authorize_web_portal), 1),
                    _createElementVNode("li", null, "- " + _toDisplayString(_ctx.language.authorize_web_portal_click_acct), 1),
                    _createElementVNode("li", null, "- " + _toDisplayString(_ctx.language.authorize_web_portal_click_trans), 1),
                    _createElementVNode("li", null, "- " + _toDisplayString(_ctx.language.authorize_web_portal_click_enable), 1)
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", _hoisted_70, _toDisplayString(_ctx.language.activate), 1)
                ])
              ])
            ])
          ]),
          _hoisted_71,
          (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
            _createVNode(_component_InvoiceOptionsSettingsModal, {
              visible: _ctx.isDialogOpen,
              initialValues: _ctx.dialogRecordData,
              recordStatus: _ctx.dialogRecordStatus,
              lstOfCurrencies: _ctx.listOfCurrencies,
              onCloseForm: _ctx.onCloseForm
            }, null, 8, ["visible", "initialValues", "recordStatus", "lstOfCurrencies", "onCloseForm"])
          ]))
        ])
      ]))
}